import { useMemo } from 'react'

import { useGamificationData } from '@/shared/hooks/useGamificationData'

interface UseHelpCenterStoreProps {
  id?: number
  uid?: string
}

export const useHelpCenterStore = ({
  id,
  uid
}: UseHelpCenterStoreProps = {}) => {
  const data = useGamificationData()
  const postsRaw = data?.posts ?? []

  const posts = useMemo(() => {
    const sortedPosts = postsRaw.sort((a, b) => {
      return new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
    })

    return sortedPosts.map(post => {
      return { ...post }
    })
  }, [postsRaw])

  const post = useMemo(() => {
    if (!id && !uid) return null
    return posts.find(p => p.id === id || p.uid === uid)
  }, [posts, id, uid])

  return { posts, post }
}
